// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { auditEventsResponseSchema } from '@/audit/api/types';

/**
 * Fetches audit events for a single charge by its nano-id key.
 */
export async function getChargeAuditEvents(chargeKey: string) {
  const url = `/v1/charge/${chargeKey}/audit`;
  const response = await api.get(url);

  return parseResponse(auditEventsResponseSchema, response.data, {
    schemaName: 'ChargeAuditEvents',
    endpoint: url,
  });
}
